import { render, staticRenderFns } from "./VAlert.vue?vue&type=template&id=15fdb326&scoped=true&"
import script from "./VAlert.vue?vue&type=script&lang=js&"
export * from "./VAlert.vue?vue&type=script&lang=js&"
import style0 from "./VAlert.vue?vue&type=style&index=0&id=15fdb326&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15fdb326",
  null
  
)

export default component.exports